import { useMutation } from '@tanstack/react-query';
import { type AxiosError } from 'axios';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface UploadCostumeImageParams {
  actId: string;
  performanceId: string;
  file: File;
}

export interface UploadCostumeImageResponse {
  url: string;
  filename: string;
}

export const uploadCostumeImageAPI = async ({
  actId,
  performanceId,
  file,
}: UploadCostumeImageParams) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await baseAPI.post<UploadCostumeImageResponse>(
    `/acts/${actId}/performances/${performanceId}/costume-image`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response.data;
};

export const useUploadCostumeImageMutation = () => {
  return useMutation({
    mutationFn: async (params: UploadCostumeImageParams) => {
      return await uploadCostumeImageAPI(params);
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACTS, variables.actId, KEYS.PERFORMANCES],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PERFORMANCES, variables.performanceId],
      });
    },
    onError: (error: AxiosError<{ message: string }>) => {
      const errorMessage =
        error.response?.data.message ?? 'Failed to upload costume image';
      toast.error(errorMessage);
    },
  });
};
